export enum CarePathActivityConditionField {
    isCpap = 'isCpap',
    isReversibilityTest = 'isReversibilityTest',
}
